import { connect } from 'react-redux';

import { Entities, fetchAll, getEntities } from 'src/common';
import NotificationAdministration from 'src/components/superadmin/notifications/notification-administration';

const mapStateToProps = state => {
    return {
        notifications: getEntities(state, Entities.RECENT_OPERATOR_NOTIFICATIONS),
    };
};

const NotificationAdministrationContainer = connect(mapStateToProps, {
    fetchAll,
})(NotificationAdministration);

export default NotificationAdministrationContainer;
